import React, { useState, useContext } from "react";
import { useNavigate } from "react-router-dom";
import NavbarCustom from "../../../Components/NavbarCustom";
import Swal from "sweetalert2";
import { ParentContext } from "../../../APIContext/ParentContext";

const Register = () => {
  const { addParent } = useContext(ParentContext);
  const navigate = useNavigate();

  const [formData, setFormData] = useState({
    first_name: "",
    last_name: "",
    username: "",
    email: "",
    password: "",
    confirmPassword: "",
    phone: "",
    is_self_pay: "true",
  });

  const [errors, setErrors] = useState({});

  const validate = () => {
    const err = {};

    if (!formData.first_name.trim()) err.first_name = "First name is required";
    if (!formData.last_name.trim()) err.last_name = "Last name is required";
    if (!formData.username.trim()) err.username = "Username is required";
    if (!formData.email.trim()) err.email = "Email is required";
    if (!formData.phone.trim()) err.phone = "Phone is required";
    if (!formData.password.trim()) err.password = "Password is required";

    if (formData.password !== formData.confirmPassword)
      err.confirmPassword = "Passwords do not match";

    return err;
  };

  const handleChange = (e) => {
    setFormData((prev) => ({
      ...prev,
      [e.target.name]: e.target.value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      setErrors(validationErrors);
      Swal.fire({
        icon: "warning",
        title: "Validation Error",
        text: "Please fill all required fields correctly.",
        confirmButtonColor: "#f7931a",
        cancelButtonColor: "#1C1C1C",
      });
      return;
    }

    try {
      const payload = { ...formData };
      delete payload.confirmPassword;

      const result = await addParent(payload);

      if (result.success) {
        Swal.fire({
          icon: "success",
          title: "Account Created",
          text: "Your account has been created successfully.",
          confirmButtonColor: "#f7931a",
          cancelButtonColor: "#1C1C1C",
        });

        setFormData({
          first_name: "",
          last_name: "",
          username: "", // reset
          email: "",
          password: "",
          confirmPassword: "",
          phone: "",
          is_self_pay: "true",
        });

        setTimeout(() => navigate("/login"), 1500);
      }
    } catch (err) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Something went wrong while creating account.",
        confirmButtonColor: "#f7931a",
        cancelButtonColor: "#1C1C1C",
      });
    }
  };

  return (
    <>
      <NavbarCustom />

      <div className="auth-wrapper brightness">
        <div className="auth-side-image"></div>

        <div className="auth-card brightness">
          <div className="card-box">
            <h2 className="auth-title text-clip">REGISTER</h2>

            <form
              className="auth-form"
              style={{ marginTop: "1rem" }}
              onSubmit={handleSubmit}
            >
              {/* NAME ROW */}
              <div className="name-row">
                <div className="name-field">
                  <label className="text-clip" style={{ marginBottom: "10px" }}>
                    First Name
                  </label>
                  <input
                    type="text"
                    name="first_name"
                    value={formData.first_name}
                    onChange={handleChange}
                    className={errors.first_name ? "input-error" : ""}
                  />
                </div>

                <div className="name-field">
                  <label className="text-clip" style={{ marginBottom: "10px" }}>
                    Last Name
                  </label>
                  <input
                    type="text"
                    name="last_name"
                    value={formData.last_name}
                    onChange={handleChange}
                    className={errors.last_name ? "input-error" : ""}
                  />
                </div>
              </div>

              {/* ⭐ USERNAME FIELD */}
              <label className="text-clip" style={{ marginTop: "1rem" }}>
                Username *
              </label>
              <input
                type="text"
                name="username"
                value={formData.username}
                onChange={handleChange}
                className={errors.username ? "input-error" : ""}
              />

              <label className="text-clip" style={{ marginTop: "1rem" }}>
                Phone No. *
              </label>
              <input
                type="text"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                className={errors.phone ? "input-error" : ""}
              />

              {/* EMAIL */}
              <label className="text-clip" style={{ marginTop: "1rem" }}>
                Email Address *
              </label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                className={errors.email ? "input-error" : ""}
              />

              {/* PASSWORD */}
              <label className="text-clip" style={{ marginTop: "1rem" }}>
                Password *
              </label>
              <input
                type="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                className={errors.password ? "input-error" : ""}
              />

              {/* CONFIRM PASSWORD */}
              <label className="text-clip" style={{ marginTop: "1rem" }}>
                Confirm Password *
              </label>
              <input
                type="password"
                name="confirmPassword"
                value={formData.confirmPassword}
                onChange={handleChange}
                className={errors.confirmPassword ? "input-error" : ""}
              />

              {/* SUBMIT BUTTON */}
              <button className="auth-login-btn" style={{ marginTop: "1rem" }}>
                REGISTER
              </button>
            </form>

            <hr className="auth-divider" />

            <p className="auth-note text-clip">Already Have An Account?</p>

            <button
              className="auth-create-btn"
              onClick={() => navigate("/login")}
            >
              <span className="text-clip">LOGIN HERE</span>
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default Register;
